/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Change_Email_Address_ButtonInputs */

const en_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change your email address`)
};

const id_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah alamat email Anda`)
};

const ms_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar alamat emel anda`)
};

const ca_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canvia la teva adreça de correu electrònic.`)
};

const cs_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změňte svou emailovou adresu`)
};

const da_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift din e-mailadresse`)
};

const de_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern Sie Ihre E-Mail-Adresse`)
};

const et_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutke oma e-posti aadress`)
};

const es_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia tu dirección de correo electrónico`)
};

const fr_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l’adresse e-mail`)
};

const hr_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promijenite svoju e-mail adresu.`)
};

const it_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia il tuo indirizzo email`)
};

const lv_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomainiet savu e-pasta adresi.`)
};

const lt_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakeisti el. pašto adresą`)
};

const hu_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változtassa meg az e-mail címét`)
};

const nl_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzig je e-mailadres`)
};

const nb_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endre e-postadresse`)
};

const pl_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień swój adres e-mail`)
};

const pt_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altere seu endereço de e-mail.`)
};

const ro_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schimbați adresa de e-mail`)
};

const sk_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmeňte svoju e-mailovú adresu`)
};

const sl_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremenite svoj e-poštni naslov`)
};

const fi_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuta sähköpostiosoitettasi`)
};

const sv_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byt din e-postadress`)
};

const vi_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi địa chỉ email của bạn`)
};

const tr_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresinizi değiştirin`)
};

const el_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αλλάξτε τη διεύθυνση email σας`)
};

const bg_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Променете вашия имейл адрес.`)
};

const ru_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить адрес электронной почты`)
};

const sr_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промените своју имејл адресу`)
};

const uk_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змініть свою адресу електронної пошти`)
};

const ka_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეცვალეთ თქვენი მეილის მისამართი.`)
};

const hi_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ईमेल पता बदलें`)
};

const th_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนที่อยู่อีเมลของคุณ`)
};

const ko_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소 변경`)
};

const zh_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改您的电子邮件地址`)
};

const zh_tw_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改您的電子郵件地址`)
};

const ja_change_email_address_button = /** @type {(inputs: Change_Email_Address_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを変更`)
};

/**
* | output |
* | --- |
* | "Change your email address" |
*
* @param {Change_Email_Address_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const change_email_address_button = /** @type {((inputs?: Change_Email_Address_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Change_Email_Address_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_change_email_address_button(inputs)
	if (locale === "ms") return ms_change_email_address_button(inputs)
	if (locale === "ca") return ca_change_email_address_button(inputs)
	if (locale === "cs") return cs_change_email_address_button(inputs)
	if (locale === "da") return da_change_email_address_button(inputs)
	if (locale === "de") return de_change_email_address_button(inputs)
	if (locale === "et") return et_change_email_address_button(inputs)
	if (locale === "es") return es_change_email_address_button(inputs)
	if (locale === "fr") return fr_change_email_address_button(inputs)
	if (locale === "hr") return hr_change_email_address_button(inputs)
	if (locale === "it") return it_change_email_address_button(inputs)
	if (locale === "lv") return lv_change_email_address_button(inputs)
	if (locale === "lt") return lt_change_email_address_button(inputs)
	if (locale === "hu") return hu_change_email_address_button(inputs)
	if (locale === "nl") return nl_change_email_address_button(inputs)
	if (locale === "nb") return nb_change_email_address_button(inputs)
	if (locale === "pl") return pl_change_email_address_button(inputs)
	if (locale === "pt") return pt_change_email_address_button(inputs)
	if (locale === "ro") return ro_change_email_address_button(inputs)
	if (locale === "sk") return sk_change_email_address_button(inputs)
	if (locale === "sl") return sl_change_email_address_button(inputs)
	if (locale === "fi") return fi_change_email_address_button(inputs)
	if (locale === "sv") return sv_change_email_address_button(inputs)
	if (locale === "vi") return vi_change_email_address_button(inputs)
	if (locale === "tr") return tr_change_email_address_button(inputs)
	if (locale === "el") return el_change_email_address_button(inputs)
	if (locale === "bg") return bg_change_email_address_button(inputs)
	if (locale === "ru") return ru_change_email_address_button(inputs)
	if (locale === "sr") return sr_change_email_address_button(inputs)
	if (locale === "uk") return uk_change_email_address_button(inputs)
	if (locale === "ka") return ka_change_email_address_button(inputs)
	if (locale === "hi") return hi_change_email_address_button(inputs)
	if (locale === "th") return th_change_email_address_button(inputs)
	if (locale === "ko") return ko_change_email_address_button(inputs)
	if (locale === "zh") return zh_change_email_address_button(inputs)
	if (locale === "zh-tw") return zh_tw_change_email_address_button(inputs)
	if (locale === "ja") return ja_change_email_address_button(inputs)
	return en_change_email_address_button(inputs)
});